var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box has-bg-img",style:({ backgroundImage: 'url(' + _vm.businessLogoURL + ')' }),attrs:{"id":"logo-div"}})}
var staticRenderFns = []

export { render, staticRenderFns }